import { c as _c } from "react/compiler-runtime";
import { Accordion, AccordionControl, AccordionItem, AccordionPanel } from "@mantine/core";
import PureHtml from "@/components/custom/PureHtml";

// Reusable FAQ section used across product / collection / brand / blog pages.
// Render the same array that feeds the FAQPage JSON-LD (see @/shared/seo/faqs)
// so visible content matches structured data.
export default function CommonFaqs(t0) {
  const $ = _c(14);
  const {
    faqs: t1,
    heading: t2,
    subtext
  } = t0;
  let t3;
  if ($[0] !== t1) {
    t3 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const faqs = t3;
  const heading = t2 === undefined ? "Frequently Asked Questions" : t2;
  if (!faqs?.length) {
    return null;
  }
  let t4;
  if ($[2] !== heading) {
    t4 = <h2 className="text-xl lg:text-2xl">{heading}</h2>;
    $[2] = heading;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== subtext) {
    t5 = subtext && <PureHtml html={subtext} />;
    $[4] = subtext;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== faqs) {
    t6 = faqs.map(_temp);
    $[6] = faqs;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t6) {
    t7 = <div className="bg-white rounded p-2 shadow"><div className="grid grid-cols-1 lg:grid-cols-2 gap-2">{t6}</div></div>;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t4 || $[11] !== t5 || $[12] !== t7) {
    t8 = <section className="section-faqs bg-gray-50 py-2 lg:py-3" id="faqs"><div className="max-w-7xl mx-auto px-2">{t4}{t5}{t7}</div></section>;
    $[10] = t4;
    $[11] = t5;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  return t8;
}
function _temp(faq, index) {
  return <Accordion key={index} variant="separated" transitionDuration={1000} className="w-full" chevronIconSize={24}><AccordionItem value={faq.question}><AccordionControl aria-label={faq.question} bg="gray.1" className="rounded-t-sm"><h3 className="text-base mb-0">{faq.question}</h3></AccordionControl><AccordionPanel><PureHtml html={faq.answer} /></AccordionPanel></AccordionItem></Accordion>;
}